import jquery from 'jquery';
window.jQuery = jquery;
window.$ = jquery;

import bootstrap from './bootstrap';
window.bootstrap = bootstrap

import smartTab from "jquery-smarttab";
window.smartTab = smartTab;

import moment from "moment"
window.moment = moment

// import './daterangepicker'

import DataTable from "datatables.net-bs5"
window.DataTable = DataTable(window, $);

// import * as echarts from './apacheecharts';
// window.echarts = echarts

import Buttons from "datatables.net-buttons-bs5"
Buttons(window, $);

import buttonsHtml5 from "datatables.net-buttons/js/buttons.html5.js"
buttonsHtml5(window, $);

import JSZip from 'jszip';
window.JSZip = JSZip


import perfectScrollbar from "perfect-scrollbar"
window.PerfectScrollbar = perfectScrollbar

// import select2 from 'select2'
// window.select2 = select2()

// import LocalTime from "local-time"
// LocalTime.start()


  









